import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";
import AffiliationRequestsActions, { AffiliationRequestsTypes } from '../redux/AffiliationRequests';
import MessageActions from "../redux/Messages";
import AuthActions from "../redux/Auth";
import UserActions from "../redux/User";
import { 
  getAffiliationRequestsRequest,
  addAffiliationRequestRequest,
  deleteAffiliationRequestRequest,
} from "../services/AffiliationRequests";

function* getAffiliationRequests() {
  try {
    yield put(AuthActions.showAuthLoader())
    const {user: { id }} = yield select(state => state.user);
    const affiliationRequests = yield call(getAffiliationRequestsRequest, id);
    yield put(AffiliationRequestsActions.getAffiliationRequestsDone(affiliationRequests))
    yield put(AuthActions.hideAuthLoader())
  } catch (error) {
    yield put(AffiliationRequestsActions.getAffiliationRequestsError(error))
  }
}

function* addAffiliationRequest({ targetUserId }) {
  yield put(AuthActions.showAuthLoader())
  const {user: { id, rol }} = yield select(state => state.user);
  yield call(addAffiliationRequestRequest, targetUserId, id);
  if (rol === 'client')
    yield put(UserActions.getAllMajors());
  else
    yield put(UserActions.getAllClients());
  yield put(MessageActions.showMessage('Orden creada con exito', false));
}

function* deleteAffiliationRequest({ targetId, affiliationId }) {
  const { user: { id } } = yield select(state => state.user);
  console.log(targetId === id, "ALV");
  yield put(AuthActions.showAuthLoader());
  yield call(deleteAffiliationRequestRequest, targetId, affiliationId, id);
  yield put(AffiliationRequestsActions.getAffiliationRequests());
}

export function* getAffiliationRequestsWatcher() {
  yield takeEvery(AffiliationRequestsTypes.GET_AFFILIATION_REQUESTS, getAffiliationRequests);
}

export function* addAffiliationRequestWatcher() {
  yield takeEvery(AffiliationRequestsTypes.ADD_AFFILIATION_REQUEST, addAffiliationRequest);
}

export function* deleteAffiliationRequestWatcher() {
  yield takeEvery(AffiliationRequestsTypes.DELETE_AFFILIATION_REQUEST, deleteAffiliationRequest);
}

export default function* rootSaga() {
  yield all([
    fork(getAffiliationRequestsWatcher),
    fork(addAffiliationRequestWatcher),
    fork(deleteAffiliationRequestWatcher),
  ]);
}